import React, { Fragment, useState, useRef, useEffect } from 'react';
import styled from '@emotion/styled';

const ArticleWrapper = styled('div')`
  .article-text {
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 90px;
  }

  .arcticle-tooltip {
    margin-top: -20px;
  }
`;

const Editable = (props) => {
  const {
    disabled,
    placeholder = '',
    value,
    isInvalid = false,
    onChange = () => false,
    currentInput,
    notSaveOnEnter,
    notSaveOnBlur,
    preventFocus,
    toggleInput = () => false,
    handleUpdate,
    handleCancel,
    activeTab,
  } = props;

  const [loading, toggleLoading] = useState(false);

  const inputEl = useRef(null);
  const inputWrapperEl = useRef(null);

  useEffect(() => {
    if (currentInput) {
      if (!preventFocus) inputEl.current.focus();
    } else {
      if (loading) {
        toggleLoading(false);
      }
    }
  }, [currentInput]);

  useEffect(() => {
    if (!currentInput) return () => null;
    const listener = (e) => {
      const isClickInside = inputWrapperEl.current.contains(e.target);
      if (!isClickInside && !notSaveOnBlur && handleUpdate) {
        handleUpdate();
      }
    };
    document.body.addEventListener('mousedown', listener, false);
    return () => {
      document.body.removeEventListener('mousedown', listener, false);
    };
  });

  useEffect(() => {
    toggleLoading(false);
  }, [value]);

  const setValue = () => {
    handleUpdate();
    toggleLoading(true);
  };

  let strClassName = 'editable editable-click variant-input';
  if (!value) strClassName += ' empty-variant-prop';
  if (disabled) strClassName += ' disabled-variant-prop';

  let inputClassName = 'form-control form-control-sm variant-input';
  if (isInvalid) inputClassName += ' is-invalid';

  return (
    <Fragment>
      {!currentInput ? (
        <ArticleWrapper>
          <div className={strClassName} onClick={toggleInput} data-testid="editable-click">
            <span className="help-tooltip-wrapper">
              <span className="article-text">{value}</span>
              {value?.length > 9 ? (
                <span className="help-tooltip arcticle-tooltip">{value}</span>
              ) : null}
            </span>
          </div>
        </ArticleWrapper>
      ) : (
        <span className="editable-container editable-inline" data-testid="editable-container">
          <div>
            {loading ? (
              <div className="editableform-loading" data-testid="editableform-loading"></div>
            ) : (
              <div className="form-inline editableform">
                <div className="control-group form-group">
                  <div>
                    <div
                      className="editable-input"
                      style={{ position: 'relative' }}
                      ref={inputWrapperEl}
                    >
                      <input
                        type="text"
                        className={inputClassName}
                        style={{ paddingRight: '24px' }}
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                        onKeyDown={(e) =>
                          e.key === 'Enter' && !notSaveOnEnter && !isInvalid ? setValue() : null
                        }
                        ref={inputEl}
                      />
                      {value ? (
                        <span
                          className="editable-clear-x"
                          data-testid="editable-clear-x"
                          onClick={() => onChange({ target: { value: '' } })}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </span>
      )}
    </Fragment>
  );
};

export default Editable;
